import React, { useState, useEffect } from 'react';
import { Table, Form, Input, Button, Space, Select, Tag, message } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { getAlerts } from '../../api/auth';
import { useVisibleFields } from '../../hooks/usePermission';

const TYPE_OPTIONS = ['重复授权请求', 'CPUID绑定冲突'].map((v) => ({ value: v, label: v }));
const TYPE_COLOR = { '重复授权请求': 'warning', 'CPUID绑定冲突': 'error' };

const AuthAlerts = () => {
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const fetchList = async (params = {}) => {
        setLoading(true);
        try {
            const res = await getAlerts({ page: params.page || 1, page_size: params.page_size || 10, ...params });
            if (res.code === 0) {
                setDataSource(res.data.list);
                setPagination((prev) => ({ ...prev, total: res.data.total }));
            } else {
                message.error(res.message || '获取列表失败');
            }
        } catch (error) {
            console.error('Fetch alerts failed:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleSearch = () => {
        fetchList({ ...form.getFieldsValue(), page: 1 });
    };

    const handleReset = () => {
        form.resetFields();
        fetchList({ page: 1 });
    };

    const visibleFields = useVisibleFields('auth:alerts');
    const show = (code) => visibleFields.has(code);

    const columns = [
        show('type') && {
            title: '告警类型', dataIndex: 'type', key: 'type', width: 140,
            render: (v) => <Tag color={TYPE_COLOR[v] || 'default'}>{v}</Tag>,
        },
        show('mac') && { title: 'MAC', dataIndex: 'mac', key: 'mac', width: 180 },
        show('sn') && { title: 'SN', dataIndex: 'sn', key: 'sn', width: 150 },
        show('order_no') && { title: '工单号', dataIndex: 'order_no', key: 'order_no', width: 130 },
        show('cpu_id') && { title: 'CPUID', dataIndex: 'cpu_id', key: 'cpu_id', width: 120 },
        show('email') && { title: '收件邮箱', dataIndex: 'email', key: 'email', width: 180 },
        show('time') && { title: '告警时间', dataIndex: 'time', key: 'time', width: 170 },
        show('status') && {
            title: '发送状态', dataIndex: 'status', key: 'status', width: 100,
            render: (v) => <Tag color={v === '已发送' ? 'success' : 'default'}>{v}</Tag>,
        },
    ].filter(Boolean);

    return (
        <div style={{ padding: '16px' }}>
            <Form form={form} layout="inline" style={{ marginBottom: 16, rowGap: 16 }}>
                <Form.Item name="type">
                    <Select placeholder="告警类型" allowClear options={TYPE_OPTIONS} style={{ width: 160 }} />
                </Form.Item>
                <Form.Item name="sn">
                    <Input placeholder="串码SN" allowClear style={{ width: 160 }} />
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
                    </Space>
                </Form.Item>
            </Form>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={pagination}
            />
        </div>
    );
};

export default AuthAlerts;
